import { render } from "./Draw.vue?vue&type=template&id=0be70a34&scoped=true"
import script from "./Draw.vue?vue&type=script&lang=js"
export * from "./Draw.vue?vue&type=script&lang=js"

import "./Draw.vue?vue&type=style&index=0&id=0be70a34&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be70a34"]])

export default __exports__